import { effect, teardown } from '../../../reactivity/effects.js';
import { untrack } from '../../../runtime.js';

/**
 *
 *
 */
class ResizeObserverSingleton {
	/*  */
	#listeners = new WeakMap();

	/*                                     */
	#observer;

	/*                                */
	#options;

	/*          */
	static entries = new WeakMap();

	/*                                         */
	constructor(options) {
		this.#options = options;
	}

	/**
 *
 *
 */
	observe(element, listener) {
		var listeners = this.#listeners.get(element) || new Set();
		listeners.add(listener);

		this.#listeners.set(element, listeners);
		this.#getObserver().observe(element, this.#options);

		return () => {
			var listeners = this.#listeners.get(element);
			listeners.delete(listener);

			if (listeners.size === 0) {
				this.#listeners.delete(element);
				/*                         */ (this.#observer).unobserve(element);
			}
		};
	}

	#getObserver() {
		return (
			this.#observer ??
			(this.#observer = new ResizeObserver(
				/*                       */ (entries) => {
					for (var entry of entries) {
						ResizeObserverSingleton.entries.set(entry.target, entry);
						for (var listener of this.#listeners.get(entry.target) || []) {
							listener(entry);
						}
					}
				}
			))
		);
	}
}

var resize_observer_content_box = /*           */ new ResizeObserverSingleton({
	box: 'content-box'
});

var resize_observer_border_box = /*           */ new ResizeObserverSingleton({
	box: 'border-box'
});

var resize_observer_device_pixel_content_box = /*           */ new ResizeObserverSingleton({
	box: 'device-pixel-content-box'
});

/**
 *
 *
 *
 */
export function bind_resize_observer(element, type, set) {
	var observer =
		type === 'contentRect' || type === 'contentBoxSize'
			? resize_observer_content_box
			: type === 'borderBoxSize'
				? resize_observer_border_box
				: resize_observer_device_pixel_content_box;

	var unsub = observer.observe(element, /*                     */ (entry) => set(entry[type]));
	teardown(unsub);
}

/**
 *
 *
 *
 */
export function bind_element_size(element, type, set) {
	var unsub = resize_observer_border_box.observe(element, () => set(element[type]));

	effect(() => {
		/*                                                     */
		untrack(() => set(element[type]));
		return unsub;
	});
}
